<template>
  <div>
    <Header></Header>

    <div class="AboutList">
      
      <div class="block5">
        <div class="Azg5">Что дальше?</div>
        <div class="Atxt30"><b>Библиотека фасилитатора</b> лишь начало большого пути по созданию инфраструктуры для фасилитации, рабочего кабинета фасилитатора. </br></br>Сегодня мы уже ведем разработку раздела про <b>Обучение Фасилитации</b> и большого сервиса с готовыми кейсами, сессиями под ключ и разными специальными возможностями — <b>Лабораторию Фасилитатора</b>. </br></br>Идей, как развиваться и что делать много, но мы хотим создавать этот сервис совместно, видеть слышать предложения всех заинтересованных участников в развитии Библиотеки и реагировать на предложения и идеи наших коллег, пользователей, авторов...</div>
        <div class="Atxt31">Пишите нам.</br>С благодарностью и уважением, Ром Куковякин.</div>
      </div>

      <div class="block4">
        <div class="Azg4">Возможности</div>
        <div class="pict-monik"></div>
        <div class="pict-user"></div>
        <div class="pict-moder"></div>
        <div class="Atxt20">Библиотека Фасилитатора — это сообщество, в котором каждый желающий СВОБОДНО может зарегистрироваться на сайте и стать Пользователем. </br>По желанию подать заявку и получить права и возможности Модератора в системе.</div>
        <div class="Atxt21">Регистрация в Библиотеке бесплатная и пользователем может стать каждый желающий.</br></br>После регистрации у пользователя открывается доступ к Личному Кабинету.</div>
        <div class="Atxt22">Управление Личным Кабинетом.</div>
        <div class="Atxt23">Пользователь</div>
        <div class="Atxt24">Есть Личный Кабинет и возможность редактировать информацию о себе.</br></br>Может отмечать карточки с методами и собирать свою ленту методов и интрументов. </br></br>Комментировать карточки с методами и инструментами.</div>
        <div class="Atxt25">Модератор</div>
        <div class="Atxt26">+ Может создавать и редактировать свои  карточки с методами и инструментами в Библиотеке. </br></br>+ Может редактировать и удалять комментарии к своим карточкам.</div>
      </div>

      <div class="block3">
        <div class="Atxt10">По клику открывается страница с описанием метода или инструмента. К уже представленной в карточке информации на странице добавлено краткое описание, варианты применения, ссылка на модератора и время создания...</div>
        <div class="Atxt11">Мы постарались удобно сборать разные возможные компоненты для объемного содержания методов и инструментов. Шаблон описания помогает быстро и удобно ориентироваться в информации.</div>
        <div class="Atxt12">Обложка метода или инструмента, дублирует информацию с карточки и добавляется ссылка на модератора. Ниже расположена кнопка на комментарии и обсуждения.  </div>
        <div class="Atxt13"><b>Краткое описание.</b> Может как полностью описывать метод и способы его проведения, так и представлять только авторскую разработку.</br></br><b>Применение.</b> Список вариантов использования или назначения для этого метода.</div>
        <div class="Atxt14"><b>Историческая справа.</b> Указание как и где появился этот метод или инструмент, кто авторы и как он развивался.</div>
        <div class="Atxt15"><b>Файлы и документы для скачивания.</b> Модератор может загружать полезные на его взгляд материалы: статьи, инструкции, шаблоны, руководства, слайды для проведения..</div>
        <div class="Atxt16"><b>Ссылки на другие ресурсы и источники.</b> Сегодня в интернете есть много авторского контента и видео-роликов, сообщества и даже фирменные сайты по методам и инструментам.</div>
        <div class="Atxt17"><b>Фотографии и изображения.</b> Полезный визуальный контент для работы или понимания методики или примеры, как это делать...</div>
        <div class="pict-card"></div>

      </div>

      <div class="block2">
        <div class="Azg2">Как устроена библиотека?</div>
        <div class="Atxt3">Все методы, инструменты и технологии объединены </br>в <b>семь основных этапов</b> сессии.</div>
        <div class="Atxt7">Каждый этап имеет своё цветовое обозначение. Цифрой обозначается количество карточек с методами и интрументами внутри этапа.</div>
        <div class="Aetapi"></div>
        <div class="Atxt4">Отдельно выделены </br>два раздела библиотеки:</div>
        <div class="Aosnovi"></div>
        <div class="Aeshe"></div>
        <div class="Atxt5">Здесь размещаются статьи и материалы по основам фасилитации:</br>— Что такое фасилитация</br>— Групповая динамика</br>— Компетенции фасилитатора</br>...</div>
        <div class="Atxt6">Место для энерджайзеров, активностей, специализарованных методик и всего, что не входит в семь основных этапов.</div>
        <div class="Atxt9">На главной странице отображаются все карточки с методами и инструментами. Внутри каждого этапа размещаются соответствующие карточки. Есть виды сортировки по времени добавления, по популярности, по алфавиту...</div>
        <div class="Atxt8">Карточки в каталоге Библиотеки, наглядны, понятны и удобны в использовании. Содержат в себе набор информации: название, количество участников, время проведения, аннотацию и каким этапам в сессии соответствует.</div>
        <div class="Akartochki"></div>
      </div>

      <div class="block1">
        <div class="Azg1">Что это такое?</div>
        <div class="Atxt1">Для разработки и проведения групповых сессий нужны <b>методы</b> и <b>инструменты групповой работы</b>. Их более 500, единой базы нет, стандартов описания тоже. Приходится, собирать свою библиотеку из книг, из личных записей с тренингов и конференций, из интернета... </div> <!-- но это всё отнимает много времени, разного качества и часто не хватает поддержки экспертов и сообщества в вопросах применения. -->
        <div class="Atxt2">А что если создать <b>профессиональную библиотеку в онлайн</b>, с удобной структурой и обширным каталогом методов, инструментов и технологий, с понятным структурированным описанием, с документами, файлами, слайдами, ссылками на другие ресурсы и источники, с исторической справкой и авторами? С возможностью обсуждать и общаться с коллегами-фасилитаторами, консультироваться у экспертов...</div>
        <div class="Aava"></div>
        <div class="Aname">Ром</br>Куковякин</div>
        <div class="Ame">Фасилитатор, арт директор, информационный дизайнер, фотограф. Партнёр Уральского Центра Фасилитации «ЭНЕРГИЯ ИДЕЙ».</br></br>Занимаюсь разработкой «Библиотеки фасилитатора»</div>
      </div>
      

    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";

export default {
  components: {
    Header
  },
};
</script>

<style>
.block1{
  position: absolute;
  width: 1033px;
  height: 490px;
  left: 0px;
  top: 0px;
}

.block2{
  position: absolute;
  width: 1100px;
  height: 1347px;
  left: 0px;
  top: 0px;
}

.block3{
  position: absolute;
  width: 1008px;
  height: 1225.8px;
  left: 20px;
  top: 0px;
}

.block4{
  position: absolute;
  width: 1065px;
  height: 720px;
  left: 0px;
  top: 0px;
}

.block5{
  position: absolute;
  width: 602px;
  height: 617px;
  left: 0px;
  top: 0px;
}


.AboutList{
  position: relative;
    margin: 15px auto 50px;
    padding-left: 0px;
    width: 1100px;
    height: 4800px;
    text-align: center;
    border: 0px solid #888888;
    /* height: 2800px; */
    /* display: block; */
    /* clear: both; */
}

.AboutZg{
  width: 100%;
  padding-left: 50px;
  padding-top: 40px;
  padding-bottom: 40px;
  font-family: 'Roboto Condensed', sans-serif;
  color: #000000;
  text-align: left;
  font-weight: normal;
  font-size: 42px;
}

.Azg4{
  position: absolute;
  width: 274px;
  height: 56px;
  left: 50px;
  top: 3326px;

  font-family: Roboto Condensed;
  font-style: normal;
  font-weight: normal;
  font-size: 48px;
  text-align: left;
  line-height: 56px;

  color: #000000;
}

.Azg5{
  position: absolute;
width: 257px;
height: 56px;
left: 50px;
top: 4185px;

font-family: Roboto Condensed;
font-style: normal;
font-weight: normal;
font-size: 48px;
text-align: left;
line-height: 56px;

color: #000000;
}

.Atxt30{
position: absolute;
width: 600px;
height: 415px;
left: 52px;
top: 4271px;

font-family: Open Sans;
font-style: normal;
font-weight: 300;
font-size: 22px;
text-align: left;
line-height: 30px;

color: #000000;
}
.Atxt31{
position: absolute;
width: 339px;
height: 56px;
left: 52px;
top: 4777px;

font-family: Open Sans;
font-style: normal;
font-weight: normal;
font-size: 13px;
text-align: left;
line-height: 18px;

color: #909090;

}


.Atxt20{
  position: absolute;
width: 607px;
height: 175px;
left: 52px;
top: 3412px;

font-family: Open Sans;
font-style: normal;
font-weight: 300;
font-size: 22px;
text-align: left;
line-height: 30px;

color: #000000;
}

.Atxt21{
  position: absolute;
width: 339px;
height: 102px;
left: 689px;
top: 3416px;

font-family: Open Sans;
font-style: normal;
font-weight: normal;
font-size: 13px;
text-align: left;
line-height: 18px;

color: #909090;
}
.Atxt22{
  position: absolute;
width: 450px;
height: 82px;
left: 504px;
top: 3616px;

font-family: Open Sans;
font-style: normal;
font-weight: 300;
font-size: 22px;
text-align: left;
line-height: 30px;

color: #000000;
}
.Atxt23{
  position: absolute;
width: 165px;
height: 33px;
left: 507px;
top: 3782px;

font-family: Roboto Condensed;
font-style: normal;
font-weight: normal;
font-size: 28px;
text-align: left;
line-height: 33px;
/* identical to box height */


color: #000000;
}
.Atxt24{
  position: absolute;
width: 245px;
height: 201px;
left: 507px;
top: 3845px;

font-family: Open Sans;
font-style: normal;
font-weight: normal;
font-size: 13px;
text-align: left;
line-height: 18px;

color: #909090;
}
.Atxt25{
  position: absolute;
width: 129px;
height: 33px;
left: 825px;
top: 3782px;

font-family: Roboto Condensed;
font-style: normal;
font-weight: normal;
font-size: 28px;
text-align: left;
line-height: 33px;
/* identical to box height */


color: #000000;
}
.Atxt26{
  position: absolute;
width: 248px;
height: 140px;
left: 825px;
top: 3845px;

font-family: Open Sans;
font-style: normal;
font-weight: normal;
font-size: 13px;
text-align: left;
line-height: 18px;

color: #909090;
}

.pict-monik{
position: absolute;
width: 440px;
height: 417.64px;
left: 8px;
top: 3598px;

background: url('/img/monik.png');
background-size: cover;
}

.pict-user{
position: absolute;
width: 100px;
height: 100px;
left: 487px;
top: 3681px;

background: url('/img/pict-user.png');
background-size: cover;
}

.pict-moder{
position: absolute;
width: 100px;
height: 100px;
left: 805px;
top: 3681px;

background: url('/img/pict-moderator.png');
background-size: cover;
}

.Azg1{ 
  position: absolute;
  width: 292px;
  height: 56px;
  left: 50px;
  top: 50px;

  font-family: "Roboto Condensed";
  font-style: normal;
  font-weight: normal;
  font-size: 48px;
  text-align: left;
  line-height: 56px;

  color: #000000;
}

.Atxt1{
  position: absolute;
  width: 680px;
  height: 90px;
  left: 50px;
  top: 140px;

  font-family: Open Sans;
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  text-align: left;
  line-height: 22px;

  color: #000000;
}

.Atxt2{
  position: absolute;
  width: 680px;
  height: 280px;
  left: 50px;
  top: 240px;

  font-family: Open Sans;
  font-style: normal;
  font-weight: 300;
  text-align: left;
  font-size: 22px;
  line-height: 33px;

  color: #000000;
}

.Aava{
  position: absolute;
  width: 143px;
  height: 140px;
  left: 850px;
  top: 96px;

  background: url('/img/Rom.png');
  background-size: cover;
}

.Aname{
  position: absolute;
  width: 126px;
  height: 63px;
  left: 880px;
  top: 245px;

  font-family: Roboto Condensed;
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  text-align: left;
  line-height: 26px;

  color: #000000;
}

.Ame{
  position: absolute;
  width: 213px;
  height: 160px;
  left: 880px;
  top: 315px;

  font-family: Open Sans;
  font-style: normal;
  font-weight: 300;
  font-size: 13px;
  text-align: left;
  line-height: 18px;

  color: #000000;
}

.Azg2{
  position: absolute;
  width: 526px;
  height: 56px;
  left: 50px;
  top: 630px;

  font-family: Roboto Condensed;
  font-style: normal;
  font-weight: normal;
  font-size: 48px;
  text-align: left;
  line-height: 56px;

  color: #000000;
}

.Atxt3{
  position: absolute;
  width: 680px;
  height: 80px;
  left: 52px;
  top: 716px;

  font-family: Open Sans;
  font-style: normal;
  font-weight: 300;
  font-size: 22px;
  text-align: left;
  line-height: 33px;

  color: #000000;

}

.Atxt4{
  position: absolute;
  width: 282px;
  height: 89px;
  left: 50px;
  top: 1036px;

  font-family: Open Sans;
  font-style: normal;
  font-weight: 300;
  font-size: 22px;
  text-align: left;
  line-height: 30px;

  color: #000000;

}

.Atxt5{
  position: absolute;
  width: 248px;
  height: 113px;
  left: 371px;
  top: 1115px;

  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  text-align: left;
  line-height: 18px;

  color: #909090;
}

.Atxt6{
  position: absolute;
  width: 242px;
  height: 113px;
  left: 689px;
  top: 1115px;

  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  text-align: left;
  line-height: 18px;

  color: #909090;
}

.Atxt7{
  position: absolute;
  width: 339px;
  height: 76px;
  left: 689px;
  top: 720px;

  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  text-align: left;
  line-height: 18px;

  color: #909090;
}

.Atxt8{
  position: absolute;
  width: 339px;
  height: 108px;
  left: 689px;
  top: 1300px;

  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  text-align: left;
  line-height: 18px;

  color: #909090;
}

.Atxt9{
  position: absolute;
  width: 583px;
  height: 156px;
  left: 52px;
  top: 1294px;

  font-family: Open Sans;
  font-style: normal;
  font-weight: 300;
  font-size: 22px;
  text-align: left;
  line-height: 30px;

  color: #000000;
}

.Atxt10{
position: absolute;
width: 583px;
height: 156px;
left: 52px;
top: 2039px;

font-family: Open Sans;
font-style: normal;
font-weight: 300;
font-size: 22px;
text-align: left;
line-height: 30px;

color: #000000;
}

.Atxt11{
  position: absolute;
width: 339px;
height: 108px;
left: 689px;
top: 2043px;

font-family: Open Sans;
font-style: normal;
font-weight: normal;
font-size: 13px;
text-align: left;
line-height: 18px;

color: #909090;
}
.Atxt12{
  position: absolute;
width: 339px;
height: 108px;
left: 689px;
top: 2301px;

font-family: Open Sans;
font-style: normal;
font-weight: normal;
font-size: 13px;
text-align: left;
line-height: 18px;

color: #909090;
}
.Atxt13{
  position: absolute;
width: 339px;
height: 114px;
left: 689px;
top: 2509px;

font-family: Open Sans;
font-style: normal;
font-weight: normal;
font-size: 13px;
text-align: left;
line-height: 18px;

color: #909090;
}
.Atxt14{
  position: absolute;
width: 339px;
height: 71px;
left: 689px;
top: 2673px;

font-family: Open Sans;
font-style: normal;
font-weight: normal;
font-size: 13px;
text-align: left;
line-height: 18px;

color: #909090;
}
.Atxt15{
  position: absolute;
width: 339px;
height: 79px;
left: 689px;
top: 2820px;

font-family: Open Sans;
font-style: normal;
font-weight: normal;
font-size: 13px;
text-align: left;
line-height: 18px;

color: #909090;
}
.Atxt16{
  position: absolute;
width: 339px;
height: 77px;
left: 689px;
top: 2956px;

font-family: Open Sans;
font-style: normal;
font-weight: normal;
font-size: 13px;
text-align: left;
line-height: 18px;

color: #909090;
}
.Atxt17{
  position: absolute;
  width: 339px;
  height: 71px;
  left: 689px;
  top: 3080px;

  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  text-align: left;
  line-height: 18px;

  color: #909090;
}

.pict-card{
  position: absolute;
  width: 620px;
  height: 1035.8px;
  left: 20px;
  top: 2229px;

  background: url('/img/about-card.png');
  background-size: cover;
}


.Aetapi{
  position: absolute;
  width: 1100px;
  height: 110px;
  left: 30px;
  top: 820px;

  background: url('/img/show-menu-2.png');
  background-size: cover;
}

.Aosnovi{
  position: absolute;
  width: 146.67px;
  height: 110px;
  left: 359px;
  top: 998px;

  background: url('/img/punct-osnovi.png');
  background-size: cover;
}

.Aeshe{
  position: absolute;
  width: 91.67px;
  height: 110px;
  left: 676px;
  top: 998px;

  background: url('/img/punct-add.png');
  background-size: cover;
}

.Akartochki{
  position: absolute;
  width: 1000px;
  height: 500px;
  left: 62px;
  top: 1477px;

  background: url('/img/pict-vibor.png');
  background-size: cover;
}


</style>
